exports = module.exports = require("../../../../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._-6bOCE5L47XANllsB0-00,._380kFSAxI3u9_-Xj6UkeOU{display:-webkit-inline-box;display:-ms-inline-flexbox;display:inline-flex}._1aaQUz4PhpPJ6-IgVoUPMY{position:relative;top:2px;width:32px;height:32px;line-height:28px}html[dir] ._1aaQUz4PhpPJ6-IgVoUPMY{text-align:center}._2IaJGJrazSEDzDdY8JDtEC{display:inline-block}html[dir=ltr] ._3wk5qaQJIIHhR2b6mQicfi{padding-right:8px}html[dir=rtl] ._3wk5qaQJIIHhR2b6mQicfi{padding-left:8px}", ""]);
// Exports
exports.locals = {
	"locationPersona": "_-6bOCE5L47XANllsB0-00",
	"personaInfoWrapper": "_380kFSAxI3u9_-Xj6UkeOU",
	"roomIcon": "_1aaQUz4PhpPJ6-IgVoUPMY",
	"hoverTargetStyle": "_2IaJGJrazSEDzDdY8JDtEC",
	"readOnlyPill": "_3wk5qaQJIIHhR2b6mQicfi"
};